"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const LoadingPlaceholder_1 = __importDefault(require("../LoadingPlaceholder"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const getAdataAndLabelsFromControl_1 = __importDefault(require("./getAdataAndLabelsFromControl"));
const valueIsString_1 = __importDefault(require("../../../typeAssertions/valueIsString"));
const GraphicRenderer = ({ control, style, }) => {
    const { Render, functions: { processor }, dimentions } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    const propLabel = control.propLabel || 'label';
    const propValue = control.propValue || 'value';
    (0, useOnLoad_1.default)(control, events);
    const [data, labels] = (0, react_1.useMemo)(() => {
        try {
            return (0, getAdataAndLabelsFromControl_1.default)({
                data: control.data,
                labels: control.labels,
                propValue,
                propLabel,
            });
        }
        catch (error) {
            processor === null || processor === void 0 ? void 0 : processor.root.alert('Error', `${error}`);
            return [undefined, undefined];
        }
    }, [control.data, control.labels, propValue, propLabel, processor]);
    const width = (0, react_1.useMemo)(() => ((0, valueIsString_1.default)(style.width)
        ? dimentions.screen.width * (Number(style.width.replace('%', '')) / 100)
        : style.width), [style.width, dimentions.screen.width]);
    const height = (0, react_1.useMemo)(() => ((0, valueIsString_1.default)(style.height)
        ? dimentions.screen.height * (Number(style.height.replace('%', '')) / 100)
        : style.height), [style.height, dimentions.screen.height]);
    return (react_1.default.createElement(LoadingPlaceholder_1.default, { control: control, style: style },
        react_1.default.createElement(Render.Graphic, { width: width || 200, height: height || 160, style: style, typeGraphic: control.typeGraphic, pieColors: control.pieColors, labels: labels, data: data })));
};
exports.default = GraphicRenderer;
